<template>
  <div>
    <div class="banner">
      <img src="@/assets/images/case.jpg">
    </div>
    <div class="cp_details">
      <div class="wrap">
        <div v-for="(item, index) in caseList" :key="index">
          <div v-if="item.id == $route.query.id">
            <div class="bt"><h3>{{ item.title }}</h3></div>
            <div class="cpxq_box">
              <p>品类：{{ item.caseName }}</p>
              <p>时间：2018.11</p>
              <p>服务：{{ item.describe }}</p>
            </div>
            <div class="imgbox">
                <img v-for="(v, i) in item.imgList" :key="i" :src="require(`@/assets/images/${v}.png`)" alt="">
            </div>
          </div>
            
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  name: 'AboutUs',  // 组件名称
  data() {
      return {
        caseList: [
          {imgList: ['case12-1', 'case12-2','case12-3', 'case12-4', 'case12-5', 'case12-6', 'case12-7', 'case12-8', 'case12-9'], title: '洛克家居', describe: '一家生产高档实木家居、注重生活品质的生产商', caseName: '网站建设', type: 1, id: 1},
          {imgList: ['case7-1', 'case7-2','case7-3', 'case7-4', 'case7-5'], title: '外贸商城', describe: '一家销售手机配件公司，商品热销欧美市场', caseName: '网站建设', type: 1, id: 2},
          {imgList: ['case8-1', 'case8-2','case8-3', 'case8-4', 'case8-5', 'case8-6', 'case8-7'], title: '外贸网站', describe: '响应式外贸网站，多端自适应的品牌网站', caseName: '网站建设', type: 1, id: 3},
          {imgList: ['case3-1', 'case3-2','case3-3'], title: '金融公司', describe: '金融公司量化投资品牌网站', caseName: '网站建设', type: 1, id: 4},
          {imgList: ['case6-1', 'case6-2','case6-3', 'case6-4', 'case6-5'], title: '生鲜供应系统', describe: '一家供应早餐市场的B2B生鲜购物平台', caseName: 'APP开发', type: 2, id: 5},
          {imgList: ['case9-1', 'case9-2','case9-3', 'case9-4', 'case9-5'], title: '心理咨询系统', describe: '一家专注青少年成长，心理健康的咨询平台', caseName: 'APP开发', type: 2, id: 6},
          {imgList: ['case5-1', 'case5-2'], title: '社保卡申领', describe: '政企社保卡申领小程序', caseName: 'APP开发', type: 2, id: 7},
          {imgList: ['case10-1', 'case10-2'], title: '雅致高定', describe: '高端人群定制圈，服装私人定制', caseName: 'APP开发', type: 2, id: 8},
          {imgList: ['case4-1', 'case4-2'], title: '智慧监控', describe: '嵌入式UPS智慧监控管理系统', caseName: '视觉设计', type: 3, id: 9},
          {imgList: ['case11-1', 'case11-2','case11-3'], title: '直播室品牌物料', describe: '一家直播工作室的宣传物料', caseName: '视觉设计', type: 3, id: 10},
          {imgList: ['case2-1', 'case2-2','case2-3', 'case2-4'], title: '华润保健', describe: '华润集团旗下保健品宣传物料', caseName: '视觉设计', type: 3, id: 11},
          {imgList: ['case1-1', 'case1-2'], title: '51考拉', describe: '一个线上综合性考试平台', caseName: '视觉设计', type: 3, id: 12},
        ]
      };
    },
};
</script>

<style scoped>

.cp_details{
    overflow: hidden;
    padding:30px 0;
}
.cp_details .bt{
    overflow: hidden;
    text-align: center;
}
.cp_details .bt h3{
    font-size: 20px;
    color: #3E3A39;
    margin-bottom: 30px;
}
.cp_details .cpxq_box{
    overflow: hidden;
    border-top: 1px #cacaca solid;
    border-bottom: 1px #cacaca solid;
    padding:20px 0;
}
.cp_details .cpxq_box p{
    font-size: 14px;
    color: #595757;
    margin:0;
    line-height: 30px;
}

.cp_details .imgbox{
  width: 100%;
  margin: auto;
  padding: 30px 0;
}
.cp_details .imgbox img{
  display: block;
  width: 100%;
}
.banner{
  width: 100%;
}
.banner img{
  display: block;
  width: 100%;
}
</style>
